import { useContext, useState } from 'react';
import ShopContext from '../../../hooks/context/ShopContext';
import OwlCarousel from 'react-owl-carousel';
import AsyncImage from '../../../components/AsyncImage';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
const CarouselItem = (props) => {


  const {
    name,
    description,
    img,
    id, thumbnail
  } = props;

  return (
    <a href={"/categories/" + id
      // encodeURIComponent(name?.toLowerCase()?.replaceAll(' ', '-')).replaceAll(`'`, '%27')

    } class="category-link w-inline-block" data-wow-delay="4ms">
      <div class="category-image-block">
        {img || thumbnail ? 
        <AsyncImage 
          path={img || thumbnail}
          imageClassName='sub_cat_img'
        />
      :  
        <img class="sub_cat_img" src={"https://dss-assets.s3.amazonaws.com/images/DSS-3D-BW.webp"} alt={name} title={name} />
      }
      </div>
      <div class="category-name">{name}</div>

    </a>
  )
}
const numItemsPerPage = 5;

const CategoriesCarousel = () => {


  const {
    catProd
  } = useContext(ShopContext);
  const [page, setPage] = useState(1);

  const slice = catProd.categories.list
  ?.sort((a,b) => b?.name > a?.name ? -1: 1)
  ?.map(each =>
    <CarouselItem
    key={each.id}
      {...each}
    />
  )
  if(!slice.length) return null;

  return (
    <OwlCarousel
      items={window.innerWidth < 1200 ? window.innerWidth < 950 ? 2 : 3 : 5}
      slideBy={(window.innerWidth < 1200 ? window.innerWidth < 950 ? 2 : 3 : 5) - 1}
      className='categories-carousel-container owl-theme' margin={10} nav dots={false}>
      {slice}
    </OwlCarousel>
    // <div style={{ display: 'flex',
    // transform: `translate3d(-5336px, 0px, 0px)`,
    // transition: 'all 1s ease 0s'
    // }} className='categories-carousel-container'>
    //   <a className={'carousel-left' + (page <= 1 ? ' disabled' : '')}>&lt;</a>
    //   {slice}
    //   <a className={'carousel-right' + (page >= Math.floor(catProd.categories.list?.length / numItemsPerPage) + 1)}>&gt;</a>
    // </div>
  )

}

export default CategoriesCarousel;
